import { ProgressBar } from "./components/Progressbar";
import { useContext, useEffect, useState } from "react";
import EvaluationContext from "features/Evaluation/context";
import Timer from "./components/Timer";
import useResponsive from "hooks/useResponsive";
import { Divider } from "./components/Divider";

interface ITimerAndResponsesProps {
  remainingTime: number;
}

const TimerAndResponses = ({ remainingTime }: ITimerAndResponsesProps) => {

  const [isOpenTwoMinutes, setIsOpenTwoMinutes] = useState<boolean>(false);
  const [isScroll, setIsScroll] = useState<boolean>(false);
  const { isMinorMobile, isMobile } = useResponsive();
  const { isMinorTablet, handleOpenTimeFinishModal, handleOpenTwoMinutesModal, allQuestions, question, } =
    useContext(EvaluationContext);

  const divProgress = ` bg-01 rounded-default flex z-10  w-full ${isMinorTablet ? "flex-col items-center p-7 " : "p-14 "
    } ${isScroll ? 'fixed top-0 left-0 right-0 m-auto' : ''}`;
  const divAlternative = ` ${isMinorTablet || isScroll ? "none" : "w-230"}`;

  useEffect(() => {
    const handleScroll = () => {

      if (window.scrollY >= 220) {

        setIsScroll(true)
      } else {
        setIsScroll(false)
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="">
    <Divider isScroll={isScroll} />
    <div
      className={divProgress}
      style={{
        boxShadow: "0px 5px 8px 0px #4A4A4A38", height: isScroll ? isMobile ?'fit-content' : '68px' : 'auto', transition:
          'all 5s ease-in-out', width: isScroll ? isMobile ? '94.5%' : '936px' : 'auto'
      }}
      data-testid="timer-and-responses"
    >
      <Timer
        allQuestion={allQuestions}
        question={question?.order}
        isScroll={isScroll}
        remainingTime={remainingTime}
        isMinorTablet={isMinorTablet}
        isOpenTwoMinutes={isOpenTwoMinutes}
        setIsOpenTwoMinutes={setIsOpenTwoMinutes}
        handleOpenTimeFinishModal={handleOpenTimeFinishModal}
        handleOpenTwoMinutesModal={handleOpenTwoMinutesModal}
        isMinorMobile={isMinorMobile}
      />
      {
        !isScroll &&
        <ProgressBar isMinorTablet={isMinorTablet} />
      }
      <div className={divAlternative}></div>
    </div>
    </div>
  );
};

export default TimerAndResponses;
